const organizationDataActions = {
  ORGANIZATION_DATA_PROP_SET: 'ORGANIZATION_DATA_PROP_SET'
};

export default organizationDataActions;